import {
  DEPRECIACION_DASHBOARD_REQUEST,
  DEPRECIACION_DASHBOARD_SUCCESS,
  DEPRECIACION_DASHBOARD_FAIL
} from './types';

import { Dispatch } from 'redux';
import axiosInstance from '../../../services/axiosConfig';
import { InventarioCompleto } from '../../../components/Inventario/ModificarInventario';

export const depreciacionDashboardActions = (activoSeleccionado: Record<string, any>[]) => async (dispatch: Dispatch): Promise<Array<InventarioCompleto> | null> => {

  if (!activoSeleccionado || activoSeleccionado.length === 0) {
    return [];
  }

  dispatch({
    type: DEPRECIACION_DASHBOARD_REQUEST
  });

  try {
    const activosDepreciacion = activoSeleccionado.map((item) => ({
      AF_CLAVE: item.aF_CLAVE,
      FECHA_ALTA: item.FECHA_ALTA ?? item.fechA_ALTA,
      AF_PRECIO_REF: item.aF_PRECIO_REF,
      AF_VIDAUTIL: item.aF_VIDAUTIL,
      ORIGEN: item.ORIGEN ?? item.origen,
      CTA_COD: item.ctA_COD,
      AF_3UTM: item.aF_3UTM
    }));
    const res = await axiosInstance.post(`${import.meta.env.VITE_CSRF_API_URL}/depreciacionDashboardActions`, activosDepreciacion);

    if (res.status === 200) {

      const depreciacionMensual =
        res.data?.depreciacionMensual ?? [];

      dispatch({
        type: DEPRECIACION_DASHBOARD_SUCCESS,
        payload: depreciacionMensual
      });

      return depreciacionMensual;
    }

    dispatch({
      type: DEPRECIACION_DASHBOARD_FAIL
    });

    return [];

  } catch (err: any) {

    dispatch({
      type: DEPRECIACION_DASHBOARD_FAIL,
      error: err?.message || "Error en la solicitud",
      payload:
        err?.response?.data ||
        "Error de red o del servidor"
    });

    return [];
  }
};